import { whatsappTheme } from "./constants";

export const WhatsappButtonClose = ({ onClick }: { onClick: () => void }) => {
  return (
    <button
      aria-label="Cerrar"
      onClick={onClick}
      style={whatsappTheme.buttonClose}
    >
      ×
    </button>
  );
};
